import { Injectable } from "@angular/core";
import { domain } from "../variables/domain";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { map } from "rxjs/operators";
@Injectable({
  providedIn: "root"
})
export class GetDropDownCalls {
  constructor(private http: HttpClient) { }
  getBHKTypes() {
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Authorization', localStorage.getItem('token') || '');
    return this.http
      .get(domain.dropdownCalls + 'getBHKTypes', {
        headers,
      })
      .pipe(map((res:any) => res));
  }
  getDealingTypes() {
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Authorization', localStorage.getItem('token') || '');
    return this.http
      .get(domain.dropdownCalls + 'getDealingTypes', {
        headers,
      })
      .pipe(map((res:any) => res));
  }
  getEstateTypes() {
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Authorization', localStorage.getItem('token') || '');
    return this.http
      .get(domain.dropdownCalls + 'getEstateTypes', {
        headers,
      })
      .pipe(map((res:any) => res));
  }
  getFurnishedTypes() {
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Authorization', localStorage.getItem('token') || '');
    return this.http
      .get(domain.dropdownCalls + 'getFurnishedTypes', {
        headers,
      })
      .pipe(map((res:any) => res));
  }
  getParkingTypes() {
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Authorization', localStorage.getItem('token') || '');
    return this.http
      .get(domain.dropdownCalls + 'getParkingTypes', {
        headers,
      })
      .pipe(map((res:any) => res));
  }
  getPossessionTypes() {
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Authorization', localStorage.getItem('token') || '');
    return this.http
      .get(domain.dropdownCalls + 'getPossessionTypes', {
        headers,
      })
      .pipe(map((res:any) => res));
  }
  getPropertyStatusTypes() {
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Authorization', localStorage.getItem('token') || '');
    return this.http
      .get(domain.dropdownCalls + 'getPropertyStatusTypes', {
        headers,
      })
      .pipe(map((res:any) => res));
  }
  getPropertyTypesCommercial() {
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Authorization', localStorage.getItem('token') || '');
    return this.http
      .get(domain.dropdownCalls + 'getPropertyTypes?EstateTypeId=1', {
        headers,
      })
      .pipe(map((res:any) => res));
  }
  getPropertyTypesResidential() {
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Authorization', localStorage.getItem('token') || '');
    return this.http
      .get(domain.dropdownCalls + 'getPropertyTypes?EstateTypeId=2', {
        headers,
      })
      .pipe(map((res:any) => res));
  }
  getUserTypes() {
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Authorization', localStorage.getItem('token') || '');
    return this.http
      .get(domain.dropdownCalls + 'getUserTypes', {
        headers,
      })
      .pipe(map((res:any) => res));
  }

  getFloor()
  {
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Authorization', localStorage.getItem('token') || '');
    return this.http
      .get(domain.dropdownCalls + 'getFloor', {
        headers,
      })
      .pipe(map((res:any) => res));
  }
  getClientType()
  {
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Authorization', localStorage.getItem('token') || '');
    return this.http
      .get(domain.dropdownCalls + 'getClientType', {
        headers,
      })
      .pipe(map((res:any) => res));
  }
  getCities() {
    return this.http
      .get(domain.URL + 'GetAllActiveCities')
      .pipe(map((res:any) => res));
  }
  GetAnyReportMaster(StatusTypeId)
  {
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Authorization', localStorage.getItem('token') || '');
    return this.http
      .get(domain.dropdownCallsAnyReports+"GetAnyReportMaster?StatusTypeId="+StatusTypeId, {
        headers,
      })
      .pipe(map((res:any) => res));
  }
  GetAreaList() {
    const URL = domain.areaURL + "GetAreaList?" + "skip=" + 0 + "&take=" + 10000000+"&isUserDefined="+0
    return this.http
    .get(URL)
    .pipe(map((res:any) => res));
  }
  GetSocietiesList() {
    const URL = domain.societyURL + "GetSocietyList?" + "skip=" + 0 + "&take=" + 10000000+"&isUserDefined="+0
    return this.http
    .get(URL)
    .pipe(map((res:any) => res));
  }
}